import React, { useState } from 'react';
import { SaveIcon, Building2Icon, ShieldIcon, UsersIcon, LinkIcon, CreditCardIcon, DownloadIcon, CheckCircleIcon, AlertCircleIcon, TimerIcon, BellIcon, PlugIcon, FileTextIcon, MailIcon, SmartphoneIcon, KeyIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function SettingsPage() {
  const [activeTab, setActiveTab] = useState('general');
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const showToast = (message: string) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(null), 3000);
  };
  const navItems = [{
    id: 'general',
    label: 'General',
    icon: Building2Icon
  }, {
    id: 'policy',
    label: 'Travel Policy',
    icon: ShieldIcon
  }, {
    id: 'workflow',
    label: 'Approval Workflow',
    icon: CheckCircleIcon
  }, {
    id: 'approval-rules',
    label: 'Approval Rules',
    icon: TimerIcon
  }, {
    id: 'notifications',
    label: 'Notification Prefs',
    icon: BellIcon
  }, {
    id: 'integration-settings',
    label: 'Integration Settings',
    icon: PlugIcon
  }, {
    id: 'policy-mgmt',
    label: 'Policy Management',
    icon: FileTextIcon
  }, {
    id: 'users',
    label: 'Users & Roles',
    icon: UsersIcon
  }, {
    id: 'integrations',
    label: 'Integrations',
    icon: LinkIcon
  }, {
    id: 'billing',
    label: 'Billing',
    icon: CreditCardIcon
  }];
  return <div className="space-y-6" data-id="element-2547">
      <div className="flex items-center justify-between" data-id="element-2548">
        <div data-id="element-2549">
          <h2 className="text-2xl font-bold text-navy-900" data-id="element-2550">Settings</h2>
          <p className="text-slate-500" data-id="element-2551">
            Manage your organization preferences and policies.
          </p>
        </div>
        <button onClick={() => showToast('Settings saved successfully')} className="flex items-center rounded-lg bg-navy-900 px-4 py-2 text-sm font-medium text-white hover:bg-navy-700 transition-colors" data-id="element-2552">
          <SaveIcon className="mr-2 h-4 w-4" data-id="element-2553" />
          Save Changes
        </button>
      </div>

      {/* Toast */}
      {toastMessage && <div className="fixed top-20 right-6 z-50 animate-in slide-in-from-top-2" data-id="element-2554">
          <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-4 shadow-lg flex items-center gap-3" data-id="element-2555">
            <CheckCircleIcon className="h-5 w-5 text-emerald-600 flex-shrink-0" data-id="element-2556" />
            <p className="font-medium text-sm" data-id="element-2557">{toastMessage}</p>
          </div>
        </div>}

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-4" data-id="element-2558">
        {/* Settings Nav */}
        <div className="lg:col-span-1" data-id="element-2559">
          <nav className="space-y-1 rounded-xl border border-slate-200 bg-white p-2" data-id="element-2560">
            {navItems.map(item => <button key={item.id} onClick={() => setActiveTab(item.id)} className={`w-full flex items-center rounded-lg px-3 py-2 text-left text-sm font-medium transition-colors ${activeTab === item.id ? 'bg-navy-50 text-navy-700' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-2561">
                <item.icon className="mr-3 h-4 w-4" data-id="element-2562" />
                {item.label}
              </button>)}
          </nav>
        </div>

        {/* Settings Content */}
        <div className="lg:col-span-3 space-y-6" data-id="element-2563">
          {activeTab === 'general' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-6" data-id="element-2564">
              <h3 className="text-lg font-semibold text-navy-900 border-b border-slate-100 pb-4" data-id="element-2565">
                Organization Details
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2566">
                <div data-id="element-2567">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2568">
                    Organization Name
                  </label>
                  <input type="text" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="Acme Corp" data-id="element-2569" />
                </div>
                <div data-id="element-2570">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2571">
                    Industry
                  </label>
                  <select className="block w-full rounded-lg border border-slate-300 p-2.5" data-id="element-2572">
                    <option data-id="element-2573">Technology</option>
                    <option data-id="element-2574">Finance</option>
                    <option data-id="element-2575">Healthcare</option>
                    <option data-id="element-2576">Pharmaceutical</option>
                  </select>
                </div>
                <div data-id="element-2577">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2578">
                    Primary Email
                  </label>
                  <input type="email" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="admin@acme.com" data-id="element-2579" />
                </div>
                <div data-id="element-2580">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2581">
                    Phone Number
                  </label>
                  <input type="tel" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="+1 (555) 123-4567" data-id="element-2582" />
                </div>
                <div className="md:col-span-2" data-id="element-2583">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2584">
                    Address
                  </label>
                  <input type="text" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="123 Innovation Dr, San Francisco, CA 94105" data-id="element-2585" />
                </div>
              </div>
            </div>}

          {activeTab === 'policy' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2586">
              <h3 className="text-lg font-semibold text-navy-900 mb-4" data-id="element-2587">
                Travel Policy Configuration
              </h3>
              <div className="space-y-6" data-id="element-2588">
                <div data-id="element-2589">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-2590">
                    Flight Booking Cap (Domestic)
                  </label>
                  <div className="flex items-center gap-2" data-id="element-2591">
                    <span className="text-slate-500" data-id="element-2592">$</span>
                    <input type="number" className="block w-32 rounded-lg border border-slate-300 p-2 text-slate-900" defaultValue="500" data-id="element-2593" />
                    <span className="text-sm text-slate-500" data-id="element-2594">per ticket</span>
                  </div>
                </div>
                <div data-id="element-2595">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-2596">
                    Flight Booking Cap (International)
                  </label>
                  <div className="flex items-center gap-2" data-id="element-2597">
                    <span className="text-slate-500" data-id="element-2598">$</span>
                    <input type="number" className="block w-32 rounded-lg border border-slate-300 p-2 text-slate-900" defaultValue="1500" data-id="element-2599" />
                    <span className="text-sm text-slate-500" data-id="element-2600">per ticket</span>
                  </div>
                </div>
                <div className="border-t border-slate-200 pt-4" data-id="element-2601">
                  <div className="flex items-center justify-between" data-id="element-2602">
                    <div data-id="element-2603">
                      <h4 className="text-sm font-medium text-slate-900" data-id="element-2604">
                        Require Approval for All Trips
                      </h4>
                      <p className="text-xs text-slate-500" data-id="element-2605">
                        If disabled, only trips exceeding budget will require
                        approval.
                      </p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-2606">
                      <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2607" />
                      <div className="w-11 h-6 bg-slate-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-navy-700" data-id="element-2608" />
                    </label>
                  </div>
                </div>
              </div>
            </div>}

          {activeTab === 'workflow' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-6" data-id="element-2609">
              <h3 className="text-lg font-semibold text-navy-900 border-b border-slate-100 pb-4" data-id="element-2610">
                Approval Workflow Builder
              </h3>
              <div className="space-y-4" data-id="element-2611">
                {[{
              level: 1,
              role: 'Direct Manager',
              desc: 'Always required for every booking',
              threshold: null
            }, {
              level: 2,
              role: 'Department Head',
              desc: 'Required for trips exceeding threshold',
              threshold: 1000
            }, {
              level: 3,
              role: 'Finance Review',
              desc: 'Required for trips exceeding threshold',
              threshold: 2500
            }, {
              level: 4,
              role: 'VP Approval',
              desc: 'Required for trips exceeding threshold',
              threshold: 5000
            }].map(step => <div key={step.level} className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2612">
                    <div className="flex items-center gap-4" data-id="element-2613">
                      <div className="h-8 w-8 rounded-full bg-navy-100 text-navy-700 flex items-center justify-center font-bold text-sm" data-id="element-2614">
                        {step.level}
                      </div>
                      <div data-id="element-2615">
                        <h4 className="font-medium text-slate-900" data-id="element-2616">
                          {step.role}
                        </h4>
                        <p className="text-xs text-slate-500" data-id="element-2617">{step.desc}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-4" data-id="element-2618">
                      {step.threshold !== null && <div className="flex items-center gap-2" data-id="element-2619">
                          <span className="text-xs text-slate-500" data-id="element-2620">Over</span>
                          <div className="relative" data-id="element-2621">
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 text-xs" data-id="element-2622">
                              $
                            </span>
                            <input type="number" className="w-20 rounded border border-slate-300 py-1 pl-4 text-sm" defaultValue={step.threshold} data-id="element-2623" />
                          </div>
                        </div>}
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2624">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2625" />
                        <div className="w-9 h-5 bg-slate-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-navy-700" data-id="element-2626" />
                      </label>
                    </div>
                  </div>)}
              </div>
            </div>}

          {activeTab === 'approval-rules' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-6" data-id="element-2627">
              <h3 className="text-lg font-semibold text-navy-900 border-b border-slate-100 pb-4" data-id="element-2628">
                Escalation & Delegation Settings
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2629">
                <div data-id="element-2630">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2631">
                    Warning Threshold (hours)
                  </label>
                  <input type="number" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm" defaultValue={12} data-id="element-2632" />
                  <p className="text-xs text-slate-500 mt-1" data-id="element-2633">
                    Send warning notification after this many hours without
                    action
                  </p>
                </div>
                <div data-id="element-2634">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2635">
                    Auto-Escalate After (hours)
                  </label>
                  <input type="number" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm" defaultValue={24} data-id="element-2636" />
                  <p className="text-xs text-slate-500 mt-1" data-id="element-2637">
                    Automatically escalate to next level after this many hours
                  </p>
                </div>
                <div data-id="element-2638">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2639">
                    Auto-Approve Threshold
                  </label>
                  <div className="flex items-center gap-2" data-id="element-2640">
                    <span className="text-slate-500" data-id="element-2641">$</span>
                    <input type="number" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm" defaultValue={500} data-id="element-2642" />
                  </div>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-2643">
                    Trips under this amount skip approval workflow
                  </p>
                </div>
                <div className="flex items-end" data-id="element-2644">
                  <div className="w-full p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2645">
                    <div className="flex items-center justify-between" data-id="element-2646">
                      <div data-id="element-2647">
                        <h4 className="text-sm font-medium text-slate-900" data-id="element-2648">
                          Enable Auto-Escalation
                        </h4>
                        <p className="text-xs text-slate-500" data-id="element-2649">
                          Automatically escalate stale approvals
                        </p>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-2650">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2651" />
                        <div className="w-11 h-6 bg-slate-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-navy-700" data-id="element-2652" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-slate-200 pt-4" data-id="element-2653">
                <h4 className="font-medium text-slate-900 mb-3" data-id="element-2654">
                  Default Delegation Settings
                </h4>
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2655">
                  <div data-id="element-2656">
                    <h4 className="text-sm font-medium text-slate-900" data-id="element-2657">
                      Allow Self-Delegation
                    </h4>
                    <p className="text-xs text-slate-500" data-id="element-2658">
                      Approvers can delegate their own approvals
                    </p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer" data-id="element-2659">
                    <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2660" />
                    <div className="w-11 h-6 bg-slate-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-navy-700" data-id="element-2661" />
                  </label>
                </div>
              </div>
            </div>}

          {activeTab === 'notifications' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-6" data-id="element-2662">
              <h3 className="text-lg font-semibold text-navy-900 border-b border-slate-100 pb-4" data-id="element-2663">
                Notification Preferences
              </h3>
              <div className="space-y-4" data-id="element-2664">
                {[{
              label: 'Booking Confirmations',
              channels: {
                email: true,
                sms: true,
                push: true
              }
            }, {
              label: 'Approval Updates',
              channels: {
                email: true,
                sms: false,
                push: true
              }
            }, {
              label: 'Budget Alerts',
              channels: {
                email: true,
                sms: true,
                push: true
              }
            }, {
              label: 'Escalation Notices',
              channels: {
                email: true,
                sms: true,
                push: true
              }
            }, {
              label: 'Marketing Promotions',
              channels: {
                email: true,
                sms: false,
                push: false
              }
            }, {
              label: 'System Updates',
              channels: {
                email: true,
                sms: false,
                push: false
              }
            }].map(item => <div key={item.label} className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2665">
                    <span className="text-sm font-medium text-slate-900" data-id="element-2666">
                      {item.label}
                    </span>
                    <div className="flex items-center gap-4" data-id="element-2667">
                      <label className="flex items-center gap-1.5 text-xs text-slate-600" data-id="element-2668">
                        <input type="checkbox" className="h-4 w-4 rounded border-slate-300 text-navy-700" defaultChecked={item.channels.email} data-id="element-2669" />
                        <MailIcon className="h-3.5 w-3.5" data-id="element-2670" />
                      </label>
                      <label className="flex items-center gap-1.5 text-xs text-slate-600" data-id="element-2671">
                        <input type="checkbox" className="h-4 w-4 rounded border-slate-300 text-navy-700" defaultChecked={item.channels.sms} data-id="element-2672" />
                        <SmartphoneIcon className="h-3.5 w-3.5" data-id="element-2673" />
                      </label>
                      <label className="flex items-center gap-1.5 text-xs text-slate-600" data-id="element-2674">
                        <input type="checkbox" className="h-4 w-4 rounded border-slate-300 text-navy-700" defaultChecked={item.channels.push} data-id="element-2675" />
                        <BellIcon className="h-3.5 w-3.5" data-id="element-2676" />
                      </label>
                    </div>
                  </div>)}
              </div>
            </div>}

          {activeTab === 'integration-settings' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-6" data-id="element-2677">
              <h3 className="text-lg font-semibold text-navy-900 border-b border-slate-100 pb-4" data-id="element-2678">
                Integration Settings
              </h3>
              <div className="space-y-4" data-id="element-2679">
                <div data-id="element-2680">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2681">
                    Primary Booking Engine API Key
                  </label>
                  <div className="relative" data-id="element-2682">
                    <KeyIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-2683" />
                    <input type="password" className="w-full rounded-lg border border-slate-300 p-2.5 pl-10 text-sm font-mono" defaultValue="sk-amadeus-xxxx-xxxx-xxxx" data-id="element-2684" />
                  </div>
                </div>
                <div data-id="element-2685">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2686">
                    Webhook URL
                  </label>
                  <input type="url" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm font-mono" defaultValue="https://api.acme.com/webhooks/travel" data-id="element-2687" />
                </div>
                <div data-id="element-2688">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2689">
                    Callback URL
                  </label>
                  <input type="url" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm font-mono" defaultValue="https://api.acme.com/callbacks/booking" data-id="element-2690" />
                </div>
                <Link to="/integrations" className="inline-flex items-center text-sm font-medium text-navy-700 hover:text-navy-900" data-id="element-2691">
                  <PlugIcon className="mr-1.5 h-4 w-4" data-id="element-2692" /> Manage All
                  Integrations →
                </Link>
              </div>
            </div>}

          {activeTab === 'policy-mgmt' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-6" data-id="element-2693">
              <h3 className="text-lg font-semibold text-navy-900 border-b border-slate-100 pb-4" data-id="element-2694">
                Refund Policy Templates
              </h3>
              <div className="space-y-4" data-id="element-2695">
                {['Flights', 'Hotels', 'Insurance', 'Ground Transport', 'Ancillary'].map(service => <div key={service} className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2696">
                    <div data-id="element-2697">
                      <h4 className="font-medium text-slate-900" data-id="element-2698">{service}</h4>
                      <p className="text-xs text-slate-500" data-id="element-2699">
                        Last updated: Nov 1, 2024
                      </p>
                    </div>
                    <button className="text-sm font-medium text-navy-700 hover:text-navy-900" data-id="element-2700">
                      Edit Policy
                    </button>
                  </div>)}
              </div>
              <Link to="/refund-policies" className="inline-flex items-center text-sm font-medium text-navy-700 hover:text-navy-900" data-id="element-2701">
                <FileTextIcon className="mr-1.5 h-4 w-4" data-id="element-2702" /> View All Policies →
              </Link>
            </div>}

          {activeTab === 'users' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm text-center py-12" data-id="element-2703">
              <div className="mx-auto h-16 w-16 bg-navy-50 rounded-full flex items-center justify-center mb-4" data-id="element-2704">
                <UsersIcon className="h-8 w-8 text-navy-700" data-id="element-2705" />
              </div>
              <h3 className="text-lg font-bold text-navy-900" data-id="element-2706">
                User Management
              </h3>
              <p className="text-slate-500 mb-6" data-id="element-2707">
                8 active users, 2 pending invites
              </p>
              <Link to="/admin/users" className="inline-flex items-center justify-center rounded-lg bg-navy-900 px-6 py-2.5 text-sm font-medium text-white hover:bg-navy-700" data-id="element-2708">
                Manage Users & Roles
              </Link>
            </div>}

          {activeTab === 'integrations' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm text-center py-12" data-id="element-2709">
              <div className="mx-auto h-16 w-16 bg-navy-50 rounded-full flex items-center justify-center mb-4" data-id="element-2710">
                <LinkIcon className="h-8 w-8 text-navy-700" data-id="element-2711" />
              </div>
              <h3 className="text-lg font-bold text-navy-900" data-id="element-2712">Integrations</h3>
              <p className="text-slate-500 mb-6" data-id="element-2713">
                Manage booking engines, transport providers, and third-party
                connections
              </p>
              <Link to="/integrations" className="inline-flex items-center justify-center rounded-lg bg-navy-900 px-6 py-2.5 text-sm font-medium text-white hover:bg-navy-700" data-id="element-2714">
                Manage Integrations
              </Link>
            </div>}

          {activeTab === 'billing' && <div className="space-y-6" data-id="element-2715">
              <div className="navy-gradient rounded-xl p-6 text-white shadow-lg" data-id="element-2716">
                <div className="flex justify-between items-start mb-6" data-id="element-2717">
                  <div data-id="element-2718">
                    <h3 className="text-lg font-bold" data-id="element-2719">Enterprise Plan</h3>
                    <p className="text-slate-300 text-sm" data-id="element-2720">
                      $12/user/month • 142 active users
                    </p>
                  </div>
                  <span className="bg-gold-500 text-navy-900 text-xs font-bold px-3 py-1 rounded-full" data-id="element-2721">
                    Active
                  </span>
                </div>
                <div className="flex justify-between items-end" data-id="element-2722">
                  <div data-id="element-2723">
                    <p className="text-xs text-slate-400 uppercase tracking-wider mb-1" data-id="element-2724">
                      Next Billing Date
                    </p>
                    <p className="font-mono" data-id="element-2725">Dec 1, 2023</p>
                  </div>
                  <div className="text-right" data-id="element-2726">
                    <p className="text-2xl font-bold" data-id="element-2727">$1,704.00</p>
                    <p className="text-xs text-slate-400" data-id="element-2728">Estimated total</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm" data-id="element-2729">
                <h3 className="font-bold text-navy-900 mb-4" data-id="element-2730">Payment Method</h3>
                <div className="flex items-center justify-between p-4 border border-slate-200 rounded-lg" data-id="element-2731">
                  <div className="flex items-center gap-4" data-id="element-2732">
                    <div className="h-10 w-16 bg-slate-100 rounded flex items-center justify-center" data-id="element-2733">
                      <span className="font-bold text-slate-600 italic" data-id="element-2734">
                        VISA
                      </span>
                    </div>
                    <div data-id="element-2735">
                      <p className="font-medium text-slate-900" data-id="element-2736">
                        Visa ending in 4242
                      </p>
                      <p className="text-sm text-slate-500" data-id="element-2737">Expires 12/25</p>
                    </div>
                  </div>
                  <button className="text-sm font-medium text-navy-700 hover:text-navy-900" data-id="element-2738">
                    Update
                  </button>
                </div>
              </div>

              <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-2739">
                <div className="px-6 py-4 border-b border-slate-200" data-id="element-2740">
                  <h3 className="font-bold text-navy-900" data-id="element-2741">Invoice History</h3>
                </div>
                <table className="min-w-full divide-y divide-slate-200" data-id="element-2742">
                  <thead className="bg-slate-50" data-id="element-2743">
                    <tr data-id="element-2744">
                      <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-2745">
                        Date
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-2746">
                        Amount
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-2747">
                        Status
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 uppercase" data-id="element-2748">
                        Invoice
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200" data-id="element-2749">
                    {[{
                  date: 'Nov 1, 2023',
                  amount: '$1,680.00',
                  status: 'Paid'
                }, {
                  date: 'Oct 1, 2023',
                  amount: '$1,656.00',
                  status: 'Paid'
                }, {
                  date: 'Sep 1, 2023',
                  amount: '$1,620.00',
                  status: 'Paid'
                }].map((inv, i) => <tr key={i} data-id="element-2750">
                        <td className="px-6 py-4 text-sm text-slate-900" data-id="element-2751">
                          {inv.date}
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-900" data-id="element-2752">
                          {inv.amount}
                        </td>
                        <td className="px-6 py-4" data-id="element-2753">
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-emerald-100 text-emerald-800" data-id="element-2754">
                            {inv.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-right" data-id="element-2755">
                          <button className="text-navy-700 hover:text-navy-900" data-id="element-2756">
                            <DownloadIcon className="h-4 w-4 inline" data-id="element-2757" />
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}